import { render, staticRenderFns } from "./IndiceIggLiquor.vue?vue&type=template&id=30826795"
import script from "./IndiceIggLiquor.vue?vue&type=script&lang=js"
export * from "./IndiceIggLiquor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports